import { CardsListDefault } from './cards-list';

type CardItem = (typeof CardsListDefault)[number];

const withoutSkinplace: CardItem[] = CardsListDefault.filter(card => card.id !== 'def_card_4');
const withoutSkinplaceAndBets: CardItem[] = CardsListDefault.filter(
	card => card.id !== 'def_card_4' && card.id !== 'def_card_6'
);

const brandCardsMap: Record<string, CardItem[]> = {
	default: CardsListDefault,
	ngu3: withoutSkinplaceAndBets,
	com2: withoutSkinplaceAndBets
};

export const getCardsForBrand = (brand?: string): CardItem[] => {
	const key = brand || 'default';
	return brandCardsMap[key] || brandCardsMap.default;
};
